/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CategoryCreateSubCategoryResponse } from './CategoryCreateSubCategoryResponse';

export type CategoryCreateSubCategoryResponseApiRespoonse = {
    data?: CategoryCreateSubCategoryResponse;
    status?: CategoryCreateSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CategoryCreateSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

